module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fBxc4EsA.f7059272.woff2";